import {AbstractTaskHandler} from "./AbstractTaskHandler";
import TakipXmlParser from "../../../takip_ac/TakipXmlParser";
import UyapTakipAc from "../../../takip_ac/UyapTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {ITask} from "../GorevYoneticisiTypes";

export class UyapHizliTakipAcTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let takip: UyapTakipAc = UyapTakipAc.fromJson(task.data);
            takip.parsedFile = TakipXmlParser.fromJson(task.data.parsedFile);
            await takip.tevziAl();
            await takip.takipAc(true);
            task.response = takip;
            task.status = TaskDurum.BITTI_BASARILI;
            return task;
        } catch (e) {
            throw new Error(e.message)
        }
    }

}